window.addEventListener("DOMContentLoaded", (e) => {

	const body = $(document.body);
	const cart_count = document.getElementById('cart_count');

	woo_updated();
	body.on('updated_cart_totals', function () {
		woo_updated();
	});

	body.on('added_to_cart', function () {
		woo_updated();
	});

	body.on('wc_cart_emptied', function () {
		woo_updated();
	});

	function woo_updated() {
		if (!cart_count) {
			return
		}

		const amount = get_cookie('woocommerce_amount_in_cart');

		cart_count.innerHTML = amount;

		if (amount > 0) {
			cart_count.style.visibility = 'visible';
		} else {
			cart_count.style.visibility = 'hidden';
		}
	}
});

function get_cookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
